const closeAccordionMobile = () => { 

    /* Server a chiudere tutti gli accordion di bootstrap di base su mobile */

    const accshow = document.querySelectorAll('.accordion-collapse.show');
    const accbutt = document.querySelectorAll('.accordion-button');

    if(window.innerWidth < 1199){
        accshow.forEach(element => {
            element.classList.remove('show');
        });
        accbutt.forEach(element => {
            element.classList.add('collapsed')
        });
        
    }

};
export default closeAccordionMobile;